import EvChargingStation from './EvChargingStation'

export default EvChargingStation
